export enum VerificationTypeEnum {
	UNVERIFIED, GEOCODED, USER_VERIFIED, SYNCED_FROM_ERP
}

export const VerificationTypePairs = {
	[VerificationTypeEnum.UNVERIFIED]: 'model.enums.unverified',
	[VerificationTypeEnum.GEOCODED]: 'model.enums.geocoded',
	[VerificationTypeEnum.USER_VERIFIED]: 'model.enums.verified',
	[VerificationTypeEnum.SYNCED_FROM_ERP]: 'model.enums.syncedERP',
};